export default __webpack_public_path__ + "static/media/signatures.09ab7248.png";